import { productPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import { css } from "styled-components";

productPartNumbersStyles.erpNumberLabelText = {
    ...productPartNumbersStyles.erpNumberLabelText,

    css: css`
        ${productPartNumbersStyles.erpNumberLabelText?.css}
        padding-right: 0.4em;
        white-space: nowrap;
    `,
};

productPartNumbersStyles.customerNameLabelText = {
    ...productPartNumbersStyles.customerNameLabelText,

    css: css`
        ${productPartNumbersStyles.customerNameLabelText?.css}
        padding-right: 0.4em;
        white-space: nowrap;
    `,
};

productPartNumbersStyles.manufacturerItemLabelText = {
    ...productPartNumbersStyles.manufacturerItemLabelText,

    css: css`
        ${productPartNumbersStyles.manufacturerItemLabelText?.css}
        padding-right: 0.4em;
        white-space: nowrap;
    `,
};
